import { each } from 'lodash';

import Swiper from 'swiper';
import { deactivate } from '../utils/states';
import { setCookie } from '../utils/cookies';


export default class Promotions {
    constructor() {
        this.promotions = {
            container: document.getElementById('active-promotions'),
            closer: document.querySelector('#active-promotions button[data-close]'),
        }

        this.carousel = {
            count: 0,
            controls: this.promotions.container.querySelector('[data-controls]'),
            element: document.querySelector('.carousel[data-carousel="promotions"]'),
            slides: document.querySelectorAll('.carousel[data-carousel="promotions"] [data-slide]'),
            dots: this.promotions.container.querySelector('.nav.controls'),
            next: document.querySelector('.carousel[data-carousel="promotions"] [data-arrow][data-next]'),
            children: document.querySelector('.carousel[data-carousel="promotions"]').getAttribute('data-children') > 0,
        }

        this.toggler()
        this.createCarousel(this.carousel.element) // Init Carousel
    }

    toggler = () => {
        this.promotions.closer.addEventListener('click', (event) => {
            deactivate(this.promotions.container)
            setCookie('promo','dismiss',2)
            document.body.classList.remove('promotion--open')
        })
    }

    createCarousel(target) {
        let carousel = new Swiper(target, {
            slidesPerView: 1,
            spaceBetween: 0,
            autoplay: {
                delay: 5000,
            },
            loop: false,
            rewind: true,
            navigation: {
                nextEl: ".swiper-button-next",
            },
            pagination: {
                el: this.carousel.dots,
                clickable: false,
            },
        })
    }
}